import { replaceAll } from 'common/lib/helpers/TextUtils';
import { URL_REGEX } from 'common/lib/helpers/constants';
import * as _ from 'lodash';

export const replaceUrlsWithHyperlinkHtmlElement = str => {
    if (_.isEmpty(str)) return str;
    return str.replace(URL_REGEX, url => {
        return `<a href="${url}" rel="nofollow noreferrer noopener" target="_blank">${url}</a>`;
    });
};

export const getDescriptionRepresentation = description => {
    return replaceUrlsWithHyperlinkHtmlElement(replaceAll(description, '\n', '<br/>'));
};

export const isEmptyDescription = description => {
    if (_.isEmpty(description)) return true; // Also covers empty legacy type description which is just a string
    if (typeof description === 'string') return false;

    if (!Array.isArray(description)) return true;
    const descriptionTextsWithContent = description.map(item => item.text).filter(text => !_.isEmpty(text));
    return descriptionTextsWithContent.length === 0;
};
